import React from 'react'
import styled from 'styled-components'
import { StandardColumn } from '../../../../components/StandardPage'

export const fashionOrdersScreenKey = 'fashion_orders'

export type OrderType = {
  id: number
  clientId: number
  client: string | null
  createdAt: string
  startDateOfDelivery: string
  orderDate: string
  quantityItems: string
  quantityPieces: string
  status: boolean
  totalCost: number
  total: number
  saleStatus: string
}

const SaleStatusBadge = styled.span<{ $variant: 'closed' | 'open' | 'cancelled' }>`
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  ${props => props.$variant === 'closed' ? `
    background-color: #E9FBEF;
    color: #16A34A;
    border: 1px solid #A7E2BA;
  ` : props.$variant === 'cancelled' ? `
    background-color: #FDECEC;
    color: #DC2626;
    border: 1px solid #F3B4B4;
  ` : `
    background-color: #F8F9FA;
    color: #6B7280;
    border: 1px solid #E5E7EB;
  `}
`

const formatDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) return 'N/A'
  try {
    const d = new Date(dateStr)
    return d.toLocaleDateString('pt-BR')
  } catch {
    return 'N/A'
  }
}

const getSaleStatusVariant = (saleStatus: string): 'closed' | 'open' | 'cancelled' => {
  if (saleStatus === 'Fechado') return 'closed'
  if (saleStatus === 'Cancelado') return 'cancelled'
  return 'open'
}

const getTotalValue = (order: OrderType): number => Number(order.totalCost) || Number(order.total) || 0

export const buildFashionOrderColumns = (): StandardColumn<OrderType>[] => [
  {
    id: 'id',
    label: 'Nº do pedido',
  },
  {
    id: 'client',
    label: 'Cliente',
    cell: (order) => order.client || 'N/A',
  },
  {
    id: 'orderDate',
    label: 'Data pedido',
    accessor: (order) => order.orderDate || order.createdAt,
    cell: (order) => formatDate(order.orderDate || order.createdAt),
  },
  {
    id: 'startDateOfDelivery',
    label: 'Data entrega',
    cell: (order) => formatDate(order.startDateOfDelivery),
  },
  {
    id: 'quantityItems',
    label: 'Qtd. de itens',
    cell: (order) => order.quantityItems || '0',
  },
  {
    id: 'quantityPieces',
    label: 'Qtd. de peças',
    cell: (order) => order.quantityPieces || '0',
  },
  {
    id: 'total',
    label: 'Total (R$)',
    accessor: (order) => getTotalValue(order),
    cell: (order) =>
      new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(getTotalValue(order)),
  },
  {
    id: 'saleStatus',
    label: 'Venda',
    disableTooltip: true,
    cell: (order) => (
      <SaleStatusBadge $variant={getSaleStatusVariant(order.saleStatus)}>
        {order.saleStatus || '-'}
      </SaleStatusBadge>
    ),
  },
]
